import type {ReactElement} from 'react';

export interface TransitionablePanelV2Props {
  panelId: string;
  content: ReactElement | null;
  header: ReactElement<any> | null;
  contentKey: string;
  transitionDirection: TransitionDirection;
  imageURL?: string;
  imageSrcSet?: string;
  imageClassName?: string;
  imageAlt?: string;
  videoURL?: string;
  /** Custom right-column content. When set, takes precedence over imageURL/videoURL. */
  rightColumn?: ReactElement;
  modalId?: string;
  loadingText?: string;
  isLoading?: boolean;
  isCloseIconDisabled?: boolean;
  hideCloseIcon?: boolean;
  isScrollable?: boolean;
  closeIconClassName?: string;
  hideSeeMorePill?: boolean;
  onModalClose?: () => void;
}

export enum TransitionDirection {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}
